import { useId } from 'react';
import type { CustomFieldProps } from './types';
import { CustomFieldLabel } from './custom-field-label';
import { CustomFieldHelperText } from './custom-field-helper-text';
import { Input } from '@/components/ui/input';

export function CustomNumberField({
  title,
  placeholder,
  onValueChange,
  value,
  disabled,
  required,
  description,
  error,
}: CustomFieldProps) {
  const id = useId();
  return (
    <div className='not-first:*:mt-2 w-full'>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <Input
        id={id}
        step={1}
        type='text'
        value={parseInt(value, 10) || ''}
        disabled={disabled}
        onChange={(e) => {
          const value = e.target.value;
          if (/[0-9]+/.test(value) || value === '') {
            onValueChange?.(value);
          }
        }}
        placeholder={placeholder || title}
      />
      <CustomFieldHelperText error={error} description={description} />
    </div>
  );
}
